export enum SearchType {
    ASSET= 'Asset',
    COMMERCIAL = 'Commercial',
    CURRENT_OWNER = 'Current Owner',
    DEVELOPER = 'Developer',
    FULL = 'Full',
    LEASE_HOLD = 'Lease Hold',
    LIENS_AND_JUDGMENTS = 'Liens and Judgments',
    MINERAL_RIGHTS = 'Mineral Rights',
    PRIOR = 'Prior',
    UP_FROM_POLICY = 'Up from Policy'
}

export const getSearchType = (key: string): string => {
    return SearchType[key as keyof typeof SearchType];
}
